import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store/index'

Vue.config.productionTip = false;
import './styles/style.less';

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
